import React from 'react';
import { LayoutSection } from './LayoutSection';
import { EstimateSection } from './EstimateSection';
import { AboutBuildingSection } from './AboutBuildingSection';
import { PropertyManagerSection } from './PropertyManagerSection';
import type { Floorplan, Unit } from '../UnitTable';
import * as styles from './unitDetailOverlay.styles';

type UnitDetailSpokeContentProps = {
  unit: Unit;
  floorplan: Floorplan;
};

export const UnitDetailSpokeContent = ({ unit, floorplan }: UnitDetailSpokeContentProps) => (
  <div className={styles.sectionsContainer}>
    <LayoutSection unit={unit} floorplan={floorplan} />
    <EstimateSection unitName={unit.name} unitBeds={unit.beds} />
    <AboutBuildingSection />
    <PropertyManagerSection />
  </div>
);
